var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zhezhao" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "back", on: { click: _vm.closeSecond } }, [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("span", [_vm._v("Back")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tips" },
        [
          _c("a-icon", { attrs: { type: "exclamation-circle" } }),
          _vm._v(" "),
          _c("span", { staticClass: "tip" }, [
            _vm._v(
              "US business owners supported currently, more countries will be open\n        soon. The application terms require you to have a corporate and\n        corporate bank account."
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("Apply for a net-terms of 60 days")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "desc" }, [
        _vm._v(
          "\n      Manually apply for terms. The application pass rate is relatively high, and it is reviewed in about a day.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn", on: { click: _vm.openThird } }, [
        _c("img", { attrs: { src: require("@/assets/EIN-1x.png") } }),
        _vm._v("Manual review application for net 60 terms\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-104598ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-104598ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/creditDialog.vue
// module id = null
// module chunks = 